'use client'

import { useEffect } from 'react'
import useEnrollmentStore from '@cerifi/state/enrollment-store'
import { Input } from '@cerifi/ui/components/input'

/**
 *
 * communicates directly with the Enrollment Store to update the user's chosen dob with bigcommerce
 */
export const EnrollmentDobPicker = () => {
  const [dob, changeDob, showDob, init, showValidation] = useEnrollmentStore(
    (state) => [
      state.dob,
      state.changeDob,
      state.showDob,
      state.init,
      state.showValidation,
    ]
  )

  useEffect(() => init(), [init])

  return (
    <>
      {showDob && (
        <div className="max-w-[23rem]">
          <Input
            label="Date of Birth"
            type="date"
            data-testid="enrollment-dob"
            className="mt-3"
            value={dob}
            invalid={showValidation && !dob}
            errorMessage="Date of Birth is required"
            onChange={(v) => changeDob(v.target.value)}
          />
        </div>
      )}
    </>
  )
}
